/* eslint-disable no-useless-constructor */
import React, { Component } from "react";
import { config } from "_helpers";
import { formatDateTime } from "_helpers/helpers";
import PropTypes from "prop-types";

class ListItem extends Component {
  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
  }

  navigate(to) {
    this.props.history.push(to);
  }

  render() {
    const { uid, signature } = this.props;
    // debugger
    return (
      <div className="applicant_item list_item">
        {this.props.view ? (
          <div className="homeEmp_list">
            <div className="basic_info unavailable_employe">
              <div
                className="item_cell first_item"
                onClick={() => this.props.viewDoc(this.props.doc)}
              >
                {/* <span><input type="checkbox" /></span> */}
              </div>

              <div
                className="item_cell cursor-pointer"
                onClick={() => this.props.viewDoc(this.props.doc)}
              >
                <img
                  className="doc-list-img"
                  src={`${config.assetUrl}icons/${
                    this.props.status === 2 || this.props.status === 3
                      ? "doc-check-circle.svg"
                      : "doc-refresh-ico.svg"
                  } `}
                  alt="refresh"
                />

                <span>{this.props.doc_type_name}</span>
              </div>
              <div
                className="item_cell cursor-pointer"
                onClick={() => this.props.viewDoc(this.props.doc)}
              >
                <span>
                  {`${this.props.first_name} ${this.props.last_name}`}{" "}
                  {(this.props.user_type_id === 11 ||
                    this.props.user_type_id === 12) &&
                    "(GISS)"}
                </span>
              </div>

              <div
                className="item_cell cursor-pointer"
                onClick={() => this.props.viewDoc(this.props.doc)}
              >
                <span>{formatDateTime(this.props.created_at)}</span>
              </div>

              <div
                className="item_cell cursor-pointer created-at"
                onClick={() => this.props.viewDoc(this.props.doc)}
              >
                <span>{formatDateTime(this.props.updated_at)}</span>
              </div>
              <div className="item_cell">
                <a
                  href={`${config.baseUrl}docs/pdf/${this.props.slug}?id=${this.props.id}&uid=${uid}&signature=${signature}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${config.assetUrl}icons/doc-admin-download.svg`}
                    alt="bell"
                  />
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="homeEmp_list">
            <div className="basic_info unavailable_employe">
              <div className="item_cell first_item">
                {/* <span><input type="checkbox" /></span> */}
              </div>

              <div
                className="item_cell cursor-pointer"
                onClick={() =>
                  this.navigate(
                    `${this.props.url}/${this.props.hash}/${this.props.slug}?rehire=${this.props.rehire}`,
                  )
                }
              >
                <img
                  className="doc-list-img"
                  src={`${config.assetUrl}icons/${
                    this.props.status === 2 || this.props.status === 3
                      ? "doc-check-circle.svg"
                      : "doc-refresh-ico.svg"
                  } `}
                  alt="refresh"
                />

                <span>{this.props.doc_type_name}</span>
              </div>
              <div
                className="item_cell cursor-pointer"
                onClick={() =>
                  this.navigate(
                    `${this.props.url}/${this.props.hash}/${this.props.slug}?rehire=${this.props.rehire}`,
                  )
                }
              >
                <span>
                  {`${this.props.first_name} ${this.props.last_name}`}{" "}
                  {(this.props.user_type_id === 11 ||
                    this.props.user_type_id === 12) &&
                    "(GISS)"}
                </span>
              </div>

              <div
                className="item_cell cursor-pointer"
                onClick={() =>
                  this.navigate(
                    `${this.props.url}/${this.props.hash}/${this.props.slug}?rehire=${this.props.rehire}`,
                  )
                }
              >
                <span>{formatDateTime(this.props?.created_at) || "-"}</span>
              </div>

              <div
                className="item_cell cursor-pointer created-at"
                onClick={() =>
                  this.navigate(
                    `${this.props.url}/${this.props.hash}/${this.props.slug}?rehire=${this.props.rehire}`,
                  )
                }
              >
                <span>{formatDateTime(this.props.updated_at)}</span>
              </div>
              <div className="item_cell">
                <a
                  href={`${config.baseUrl}docs/pdf/${this.props.slug}?id=${this.props.id}&uid=${uid}&signature=${signature}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${config.assetUrl}icons/doc-admin-download.svg`}
                    alt="bell"
                  />
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

ListItem.propTypes = {
  uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  signature: PropTypes.string,
  view: PropTypes.bool,
  viewDoc: PropTypes.func,
  doc: PropTypes.object,
  status: PropTypes.number,
  doc_type_name: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  user_type_id: PropTypes.number,
  url: PropTypes.string,
  hash: PropTypes.string,
  slug: PropTypes.string,
  rehire: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  created_at: PropTypes.string,
  updated_at: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  history: PropTypes.object,
};

export { ListItem };
